import React, { useState, useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import API_BASE_URL from "./config";
import submitPaymentForm from "./desktop/submitPaymentForm";

const PAGE_CSS = `
  .plp-page { min-height:100vh; background:linear-gradient(135deg,#f0f4ff 0%,#fdf2ff 100%); display:flex; flex-direction:column; align-items:center; justify-content:center; padding:24px 16px; font-family:'Inter','Segoe UI',sans-serif; }
  .plp-card { background:#fff; border-radius:20px; box-shadow:0 8px 40px rgba(79,70,229,0.10); padding:40px 36px; width:100%; max-width:440px; box-sizing:border-box; }
  .plp-logo { text-align:center; margin-bottom:24px; }
  .plp-logo img { height:34px; }
  .plp-amount-box { background:linear-gradient(135deg,#f5f3ff,#ede9fe); border:1px solid #ddd6fe; border-radius:12px; padding:20px; margin-bottom:14px; text-align:center; }
  .plp-amount-label { margin:0 0 4px; font-size:12px; color:#7c3aed; font-weight:600; text-transform:uppercase; letter-spacing:1px; }
  .plp-amount-value { margin:0; font-size:36px; font-weight:700; color:#1e1b4b; letter-spacing:-1px; }
  .plp-desc-box { background:#fafafa; border:1px solid #e5e7eb; border-radius:12px; padding:14px 16px; margin-bottom:24px; }
  .plp-desc-label { margin:0 0 4px; font-size:11px; color:#9ca3af; text-transform:uppercase; letter-spacing:1px; }
  .plp-desc-text { margin:0; font-size:15px; color:#374151; font-weight:500; line-height:1.5; }
  .plp-note { margin:8px 0 0; font-size:13px; color:#6b7280; line-height:1.5; }
  .plp-field { display:flex; flex-direction:column; gap:5px; }
  .plp-label { font-size:13px; font-weight:600; color:#374151; }
  .plp-input { padding:11px 14px; border:1.5px solid #e5e7eb; border-radius:10px; font-size:15px; outline:none; transition:border-color 0.15s,box-shadow 0.15s; background:#fff; color:#111827; width:100%; box-sizing:border-box; }
  .plp-input:focus { border-color:#6d28d9; box-shadow:0 0 0 3px rgba(109,40,217,0.12); }
  .plp-input::placeholder { color:#d1d5db; }
  .plp-form { display:flex; flex-direction:column; gap:14px; }
  .plp-pay-btn { width:100%; padding:14px; background:linear-gradient(135deg,#4f46e5,#7c3aed); color:#fff; border:none; border-radius:10px; font-size:16px; font-weight:700; cursor:pointer; letter-spacing:0.2px; transition:opacity 0.15s,transform 0.1s; margin-top:6px; }
  .plp-pay-btn:hover:not(:disabled) { opacity:0.92; transform:translateY(-1px); }
  .plp-pay-btn:disabled { opacity:0.65; cursor:not-allowed; }
  .plp-error { background:#fef2f2; border:1px solid #fecaca; border-radius:8px; padding:11px 14px; color:#b91c1c; font-size:13px; display:flex; gap:8px; align-items:flex-start; line-height:1.5; }
  .plp-secure { text-align:center; font-size:12px; color:#9ca3af; margin-top:18px; line-height:1.5; }
  .plp-receipt { background:#f9fafb; border:1px solid #e5e7eb; border-radius:12px; padding:18px 20px; margin:20px 0; }
  .plp-receipt-row { display:flex; justify-content:space-between; align-items:center; gap:12px; }
  .plp-receipt-label { font-size:13px; color:#6b7280; flex-shrink:0; }
  .plp-receipt-value { font-size:14px; color:#1f2937; text-align:right; }
  .plp-receipt-value.bold { font-weight:700; color:#15803d; font-size:18px; }
  .plp-receipt-divider { height:1px; background:#e5e7eb; margin:10px 0; }
  .plp-title { font-size:22px; font-weight:700; color:#1e1b4b; margin:12px 0 6px; text-align:center; }
  .plp-title.green { color:#15803d; }
  .plp-title.red { color:#b91c1c; }
  .plp-sub { color:#6b7280; font-size:14px; text-align:center; margin:0 0 20px; line-height:1.6; }
  .plp-icon-circle { width:72px; height:72px; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; }
  .plp-icon-circle.green { background:#f0fdf4; }
  .plp-icon-circle.red { background:#fef2f2; }
  .plp-icon-circle.neutral { background:#f5f3ff; }
  .plp-retry-btn { display:block; text-align:center; padding:13px; background:linear-gradient(135deg,#4f46e5,#7c3aed); color:#fff; border-radius:10px; text-decoration:none; font-weight:700; font-size:15px; margin:4px 0 12px; }
  .plp-footer-note { text-align:center; font-size:12px; color:#9ca3af; margin:4px 0 0; line-height:1.5; }
  .plp-spinner { width:36px; height:36px; border:3px solid #e5e7eb; border-top:3px solid #4f46e5; border-radius:50%; animation:plp-spin 0.8s linear infinite; margin:0 auto; }
  @keyframes plp-spin { to { transform:rotate(360deg); } }
  @media (max-width:480px) { .plp-card { padding:28px 20px; border-radius:16px; } .plp-amount-value { font-size:28px; } }
`;

export default function PaymentLinkPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("status");

  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const payuFormRef = useRef(null);
  const [payuData, setPayuData] = useState(null);

  useEffect(() => {
    if (token === "invalid") { setLoading(false); return; }
    fetch(`${API_BASE_URL}/api/payment-link/${token}`)
      .then((r) => {
        if (r.status === 404) { setNotFound(true); setLoading(false); return null; }
        return r.json();
      })
      .then((data) => { if (data) setLink(data); setLoading(false); })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [token]);

  useEffect(() => {
    // Same helper as the other three flows: a real form POST in the browser,
    // a dedicated payment window on desktop where that submit is blocked.
    if (payuData) submitPaymentForm(payuFormRef.current, payuData.payuUrl, payuData.params);
  }, [payuData]);

  const handlePay = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError("Please fill in all fields.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/payment-link/${token}/initiate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Something went wrong. Please try again."); setSubmitting(false); return; }
      setPayuData(data);
    } catch {
      setError("Network error. Please check your connection and try again.");
      setSubmitting(false);
    }
  };

  const fmt = (n) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n);

  if (loading) {
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <div className="plp-card" style={{ textAlign: "center" }}>
          <div className="plp-spinner" />
          <p className="plp-sub" style={{ marginTop: 16 }}>Loading…</p>
        </div>
      </div>
    );
  }

  if (token === "invalid" || notFound || (!link && !paymentStatus)) {
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <Logo />
        <div className="plp-card" style={{ textAlign: "center" }}>
          <div className="plp-icon-circle neutral"><span style={{ fontSize: 30 }}>🔗</span></div>
          <h1 className="plp-title">Link Not Found</h1>
          <p className="plp-sub">This payment link doesn't exist or has been removed.</p>
        </div>
      </div>
    );
  }

  // ── Success screen ──
  if (paymentStatus === "success") {
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <Logo />
        <div className="plp-card">
          <div className="plp-icon-circle green" style={{ margin: "0 auto 12px" }}>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M8 18.5l7 7 13-14" stroke="#15803d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1 className="plp-title green">Payment Successful!</h1>
          <p className="plp-sub">Your payment has been received. Thank you!</p>

          {link && (
            <div className="plp-receipt">
              <div className="plp-receipt-row">
                <span className="plp-receipt-label">Amount Paid</span>
                <span className="plp-receipt-value bold">{fmt(link.amount)}</span>
              </div>
              <div className="plp-receipt-divider" />
              <div className="plp-receipt-row">
                <span className="plp-receipt-label">Description</span>
                <span className="plp-receipt-value">{link.description}</span>
              </div>
              {link.payer_name && (
                <>
                  <div className="plp-receipt-divider" />
                  <div className="plp-receipt-row">
                    <span className="plp-receipt-label">Paid by</span>
                    <span className="plp-receipt-value">{link.payer_name}</span>
                  </div>
                </>
              )}
            </div>
          )}
          <p className="plp-footer-note">You can now close this page.</p>
        </div>
      </div>
    );
  }

  // ── Failed / error screen ──
  if (paymentStatus === "failed" || paymentStatus === "error") {
    const isFailed = paymentStatus === "failed";
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <Logo />
        <div className="plp-card">
          <div className="plp-icon-circle red" style={{ margin: "0 auto 12px" }}>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M11 11l14 14M25 11L11 25" stroke="#b91c1c" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h1 className="plp-title red">{isFailed ? "Payment Failed" : "Something Went Wrong"}</h1>
          <p className="plp-sub">
            {isFailed
              ? "Your payment could not be processed. This may be due to a bank decline, insufficient funds, or a cancelled transaction."
              : "An unexpected error occurred. Please try again or contact support."}
          </p>

          {link && (
            <div className="plp-receipt" style={{ borderColor: "#fecaca" }}>
              <div className="plp-receipt-row">
                <span className="plp-receipt-label">Amount</span>
                <span className="plp-receipt-value" style={{ fontWeight: 700 }}>{fmt(link.amount)}</span>
              </div>
              <div className="plp-receipt-divider" />
              <div className="plp-receipt-row">
                <span className="plp-receipt-label">Description</span>
                <span className="plp-receipt-value">{link.description}</span>
              </div>
            </div>
          )}

          {token !== "invalid" && (
            <a href={`/pay/${token}`} className="plp-retry-btn">Try Again</a>
          )}
          <p className="plp-footer-note">
            If money was deducted from your account, it will be refunded within 5–7 business days.
          </p>
        </div>
      </div>
    );
  }

  // ── Already paid ──
  if (link.status === "paid") {
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <Logo />
        <div className="plp-card" style={{ textAlign: "center" }}>
          <div className="plp-icon-circle green"><span style={{ fontSize: 30 }}>✅</span></div>
          <h1 className="plp-title green">Already Paid</h1>
          <p className="plp-sub">This payment link has already been completed successfully.</p>
        </div>
      </div>
    );
  }

  // ── Inactive ──
  if (link.status !== "active") {
    return (
      <div className="plp-page">
        <style>{PAGE_CSS}</style>
        <Logo />
        <div className="plp-card" style={{ textAlign: "center" }}>
          <div className="plp-icon-circle neutral"><span style={{ fontSize: 30 }}>🔒</span></div>
          <h1 className="plp-title">Link Inactive</h1>
          <p className="plp-sub">This payment link is no longer active.</p>
        </div>
      </div>
    );
  }

  // ── Main payment form ──
  return (
    <div className="plp-page">
      <style>{PAGE_CSS}</style>
      {payuData && (
        <form ref={payuFormRef} action={payuData.payuUrl} method="POST" style={{ display: "none" }}>
          {Object.entries(payuData.params).map(([k, v]) => (
            <input key={k} type="hidden" name={k} value={v} />
          ))}
        </form>
      )}

      <Logo />
      <div className="plp-card">
        <div className="plp-amount-box">
          <p className="plp-amount-label">Amount Due</p>
          <p className="plp-amount-value">{fmt(link.amount)}</p>
        </div>

        <div className="plp-desc-box">
          <p className="plp-desc-label">Description</p>
          <p className="plp-desc-text">{link.description}</p>
          {link.note && <p className="plp-note">{link.note}</p>}
        </div>

        <form className="plp-form" onSubmit={handlePay}>
          <div className="plp-field">
            <label className="plp-label">Full Name</label>
            <input className="plp-input" type="text" placeholder="Your name" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div className="plp-field">
            <label className="plp-label">Email</label>
            <input className="plp-input" type="email" placeholder="your@email.com" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="plp-field">
            <label className="plp-label">Phone</label>
            <input className="plp-input" type="tel" placeholder="10-digit mobile number" value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })} required />
          </div>

          {error && (
            <div className="plp-error">
              <span>⚠️</span><span>{error}</span>
            </div>
          )}

          <button className="plp-pay-btn" type="submit" disabled={submitting}>
            {submitting ? "Redirecting to PayU…" : `Pay ${fmt(link.amount)}`}
          </button>
        </form>

        <p className="plp-secure">🔒 Secured by PayU · Your card details are never stored by us</p>
      </div>
    </div>
  );
}

function Logo() {
  return (
    <div className="plp-logo">
      <img src="/photentra-logo.png" alt="Photentra"
        onError={(e) => { e.target.style.display = "none"; }} />
    </div>
  );
}
